import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { MODULE_CLAIM } from '../_constants/module-claim';

import type { User } from '../_api/request.type';
import type { RoleClaim } from '../_types/role-claim';

type UserState = {
  user: User | undefined;
  getRole: (params: { module: string }) => RoleClaim | undefined;
  reset: VoidFunction;
  updateUser: (params: { user: User | undefined }) => void;
};

export const useUserState = create<UserState>()(
  persist(
    (set, get) => ({
      user: undefined,
      getRole: ({ module }: { module: string }) => {
        const claims = get().user?.claims ?? [];
        return claims.find((claim) => claim?.module?.id === module)?.role ?? undefined;
      },
      reset: () => set({ user: undefined }),
      updateUser: ({ user }: { user: User | undefined }) => {
        if (user?.claims) {
          const notificationCenterClaim = user.claims.find(
            (claim) => claim.module.id === MODULE_CLAIM.notificationCenterConfiguration,
          );

          if (notificationCenterClaim) {
            const updatedClaims = [
              ...user.claims,
              {
                ...notificationCenterClaim,
                module: {
                  ...notificationCenterClaim.module,
                  id: MODULE_CLAIM.notificationCenterTemplates,
                  label: 'Templates',
                },
              },
            ];

            return set({ user: { ...user, claims: updatedClaims } });
          }
        }

        return set({ user });
      },
    }),
    { name: 'ud' },
  ),
);
